import { gymRegimen } from "../../gym.ts";
import { cardioRegimen } from "../../cardio.ts";
import { restRegimen } from "../../rest.ts";
import type { Regimen } from "../../types.ts";

export const davidRegimens: Regimen[] = [gymRegimen, cardioRegimen, restRegimen];
